import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import orderStatusOptions from './order-status-options'
import { find } from 'lodash'
import { userEmailHydrator } from '../../fieldOptions/hydrators'

const columns = [
  {
    title: 'ID',
    prop: 'id'
  },
  {
    title: 'Account',
    prop: 'account_id',
    references: 'admin/accounts',
    referenceProp: 'account_name'
  },
  {
    title: 'Invoice ID',
    prop: 'invoice_id'
  },
  {
    title: 'Status',
    prop: 'order_status',
    format: value => {
      const option = find(orderStatusOptions, { value })
      return option ? option.name : value
    }
  },
  {
    title: 'Total',
    prop: 'order_total',
    format: 'currency',
    sortable: false
  },
  {
    title: 'Description',
    prop: 'description'
  },
  {
    title: 'Created',
    prop: 'created_at',
    format: 'date'
  }
]

const filters = [{
  name: 'Institution',
  prop: 'filters.account_id',
  type: 'autocomplete',
  references: 'admin/institutions',
  referenceProp: 'name',
  idProp: 'account_id',
  enabled: true
}, {
  name: 'User',
  prop: 'filters.account_id',
  type: 'autocomplete',
  references: 'admin/users',
  dataHydrator: userEmailHydrator,
  referenceProp: 'fullname',
  displayProp: 'displayVal',
  idProp: 'account_id',
  enabled: true
}, {
  name: 'Invoice ID',
  prop: 'filters.invoice_id',
  type: 'text',
  enabled: true
}, {
  name: 'A/R Date',
  prop: 'filters.ar_date',
  type: 'datepicker',
  enabled: true
}, {
  name: 'Session Sale',
  prop: 'filters.session_sale_id',
  type: 'autocomplete',
  references: 'admin/session_sales',
  referenceProp: 'title',
  enabled: false
}, {
  name: 'Status',
  prop: 'filters.order_status',
  type: 'multipleSelect',
  references: 'admin/orders',
  referenceProp: 'order_status',
  enabled: true,
  items: orderStatusOptions.map(status => {
    return {
      prop: status.value,
      title: status.name
    }
  })
}, {
  name: 'Show deleted',
  prop: 'with_deleted',
  type: 'bool',
  value: true,
  enabled: false
}]

const defaults = {
  order: [{ column: 'id', direction: 'desc' }]
}

const Orders = props => (
  <List
    title='Orders'
    apiPath='admin/orders'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Orders
